import { Card } from 'antd';
import PageTitle from '../../components/page-title';
import { AddMembersForm } from '../../components/add-members-modal';
import { addPlayersToVote, searchVoteOptions } from '../vote-manager/api';

// Trang cũ /add-user-vote — giữ cho link/bookmark cũ. Cách nhanh hơn: nút "+ Creator"
// ngay trên từng dòng ở trang Bình chọn hoặc trong trang Danh sách.
function AddUserVoteManager() {
  return (
    <div>
      <PageTitle title="+ Creator" />
      <Card style={{ maxWidth: 640 }}>
        <AddMembersForm
          targetLabel="Sự kiện bình chọn"
          targetPlaceholder="Gõ tên sự kiện"
          fetchTargets={searchVoteOptions}
          userLabel="Creator"
          submitText="Thêm vào sự kiện"
          onSubmit={(userIds, voteId) => addPlayersToVote(voteId, userIds)}
        />
      </Card>
    </div>
  );
}

export default AddUserVoteManager;
